import React, { useState } from 'react';
import PdfModal from './PdfModal';
import '../css/PdfCard2.css';

const PdfCard = ({ title, pdfUrl,pdfUrlMobile }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="pdf-card no-image-2">
        <div className="pdf-content-2">
          <h2 className="pdf-title-2">{title}</h2>
          <button
            onClick={() => setShowModal(true)}
            className="pdf-link-2"
          >
            View Full PDF
          </button>
        </div>
      </div>

      {showModal && (
        <PdfModal pdfUrl={pdfUrl} onClose={() => setShowModal(false)} pdfUrlMobile={pdfUrlMobile}/>
      )}
    </>
  );
};

export default PdfCard;
